import { render, staticRenderFns } from "./SkeletonLife.vue?vue&type=template&id=21843d44&scoped=true&"
var script = {}
import style0 from "./SkeletonLife.vue?vue&type=style&index=0&id=21843d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21843d44",
  null
  
)

export default component.exports